export default __webpack_public_path__ + "static/media/vampireinc.5a69b8a7.png";